import React from 'react'
import styled from 'styled-components'

import { connect } from 'react-redux'
import * as actions from '../../actions'

import { Link, withRouter } from 'react-router-dom'
import Table from './Table'
import DownloadBookButton from './DownloadBookButton'

import { booksOfBibleSlugObject, nextBookOfBible, unSlugify, capitalize } from '../../utils'

import Layout from './Layout'
import { CurveHeader } from '../visuals/curves'

const CurveHeaderStyled = styled(CurveHeader)`
  position: absolute;
  top: 0px;
  left: 0px;
`

const TestamentVisual = styled.div`
  position: relative;
  padding: 24px 32px;
`

const ToNextTestamentLink = styled(Link)`
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  color: #c4c4c4;
  padding-bottom: 3px;
  border-bottom: 1px solid #c4c4c4;
  float: right;
`

const TestamentTitle = styled.h1`
  margin-top: 24px;
  margin-bottom: 0px;
  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-size: 56px;
  line-height: 70px;
  color: #fff;
  text-transform: capitalize;
`

const DownloadAllButton = styled.button`
  appearance: none;
  padding: 6px 20px;
  background: none;

  border: 1px solid #f1f1f1;
  border-radius: 16px;

  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: #f1f1f1;
`

const TableWrap = styled.div`
  margin-top: 40px;
`

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({

})

class Testament extends React.Component {


  render () {
    const nextTestament = this.props.testament === 'old' ? 'new' : 'old'

    const curveColor = this.props.testament === 'old' ? 'hsl(45, 86%, 62%)' : 'hsl(190, 56%, 47%)'

    return (
      <Layout>
        <CurveHeaderStyled mainColor={curveColor} />
        <TestamentVisual>
          <ToNextTestamentLink to={`${process.env.REACT_APP_APP_HOIST}/${nextTestament}-testament`}>{`To ${capitalize(nextTestament)} Testament`}</ToNextTestamentLink>
          <TestamentTitle>{`${capitalize(this.props.testament)} Testament`}</TestamentTitle>
          <DownloadAllButton>Download All</DownloadAllButton>

          <TableWrap>
            <Table rows={booksOfBibleSlugObject[this.props.testament].map( (bookSlug, i) => [
                i+1,
                <DownloadBookButton />,
                <Link to={`${process.env.REACT_APP_APP_HOIST}/${bookSlug}`} key={bookSlug}>{unSlugify(bookSlug)}</Link>
              ])}
              rowKey='0'
              headings={['', '', '']}
              layouts={[
                {width: '24', padding: '24', side: 'left'},
                {width: '17', padding: '16', side: 'left'},
                {padding: '24', side: 'left'}
              ]}
              separators={false}
            />
          </TableWrap>


        </TestamentVisual>
      </Layout>
    )
  }
}

Testament = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Testament))

export default Testament



// WEBPACK FOOTER //
// ./src/components/Main/Testament.js